export const listWareHouses = (state) => state.listWareHouses;
export const loading = (state) => state.loading;
export const fieldWareHouses = (state) => state.fieldWareHouses;
export const pagination = (state) => (state.pagination);
